import { createEvent, sample, combine } from 'effector';
import { createForm } from 'effector-forms';
import rules from 'src/effector/forms/rules';
import { getErrors } from 'src/effector/forms/helpers';
import * as api from 'src/logic/api';

const next = createEvent();
const submit = createEvent();

const form = createForm({
  fields: {
    ein: {
      init: '',
      rules: [
        rules.required(),
        {
          name: 'ein-format',
          validator: value => /^[0-9]{2}-[0-9]{7}$/.test(value),
          errorText: 'Invalid EIN format (XX-XXXXXXX)',
        },
      ],
    },
    dateEstablished: {
      init: null,
      rules: [rules.required()],
    },
    vehicleNumber: {
      init: 0,
      rules: [
        rules.required(),
        {
          name: 'non-negative',
          validator: value => Number.isInteger(Number(value)) && value >= 0,
          errorText: 'Vehicle number must be 0 or greater',
        },
      ],
    },
  },
});

sample({
  clock: sample({
    clock: submit,
    fn: () => console.log('proprietor1submit'),
    target: form.validate,
  }),
  source: form.$isValid,
  filter: isValid => {
    console.log('proprietor1submit isValid', form);
    return isValid;
  },
  target: next,
});

const $formErrors = getErrors(Object.keys(form.fields), form);
const $isValidForm = form.$isValid.map(isValid => isValid);

export const stores = {
  form,
  $formErrors,
  $isValidForm,
};

export const store = combine(stores);

export const actions = {
  submit,
  next,
};
